module.exports = __webpack_public_path__ + "static/media/87.297aafb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/87.jpg
// module id = 1020
// module chunks = 0